import styled from 'styled-components';
import { SIZE } from '@app/src/ui';
import { NavBar } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';

interface Props {
  isDisplay?: boolean;
}

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: blocK;
  transition: transform 500ms ease-in-out;
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 100vh;
  }
`;

export const NavBarResponsive = styled(NavBar)`
  height: 50px;
  font-size: 9.5px;
  display: ${(props:Props) => props.isDisplay ? 'flex' : 'none'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  a {
    padding: 0 6px;
  }
  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    display: none;
  }
`;

export const NavBarResponsiveFixed = styled(NavBar)`
  display:none;
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 50px;
  font-size: 9.5px;
  display: ${(props:Props) => props.isDisplay ? 'flex' : 'none'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  a {
    padding: 0 6px;
  }
`;

export const FooterWrapper = styled(FooterFeature)`
  display: block;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: none;
  }
`;
